<script>
import {defineComponent} from 'vue'
import {IonCardContent, IonPage,} from "@ionic/vue";
import {AppApi} from "@/api/AppApi";
import AjaxForm from "@/components/AjaxForm.vue";
import AliSelect from "@/components/aliSelect/index.vue";
import {showSystemNoti} from "@/shared/helper";

export default defineComponent({
  name: "AddNewMessage" ,
  methods: {
    submitCallback(data)
    {
      if (data.ok)
      {
        this.$refs.form.reset();
        showSystemNoti('success',data.message);
      }
      else
        showSystemNoti('danger',data.error);
    }
  },
  components: {AjaxForm, IonPage, IonCardContent,AliSelect},
  data()
  {
    return{
      visitors : [],
      send_to_all : false
    }
  },
  mounted()
  {
    this.send_to_all = false;
    AppApi.getAllVisitorsForSelect().then((result)=>{
      if (result.ok)
        this.visitors = result.visitors;
    })
  },
})
</script>

<template>
  <ion-page>
    <master-layout pageTitle="ثبت پیام جدید">
      <IonCardContent>
        <ajax-form route="Message/AddNewMessage" ref="form" :callback="submitCallback">
          <div class="form-group">
            <label>عنوان پیام</label>
            <input type="text" name="title" class="form-control" placeholder="عنوان پیام را وارد کنید">
          </div>
          <div class="form-group">
            <label>متن پیام</label>
            <textarea name="content" placeholder="متن پیام ..." class="form-control"></textarea>
          </div>
          <div class="form-group">
            <input autocomplete="off" type="checkbox"
                   class="form-check-input"
                   name="send_to_all"
                   v-model="send_to_all"
                   value="1"
                   id="exampleCheck1">
            <label class="form-check-label" for="exampleCheck1">ارسال به همه</label>
          </div>
            <div class="form-group">
              <div class="text-danger">در صورت انتخاب نکردن دریافت کننده پیام فقط برای مدیریت قابل مشاهده می باشد</div>
            <label>دریافت کنندگان پیام</label>
            <ali-select :disabled="send_to_all" name="visitor_ids" :multiple="true" item-id="_id" item-title="fullname" :items="visitors"></ali-select>
          </div>
          <button class="btn btn-primary w-100 btn-block" type="submit">ارسال پیام</button>
        </ajax-form>
      </IonCardContent>
    </master-layout>
  </ion-page>
</template>

<style scoped>

</style>